module.exports = __webpack_public_path__ + "static/img/home_scenario_bg.9173e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/official/home_scenario_bg.png
// module id = 1Ly+
// module chunks = 0